<template>
  <div
    class="w-full flex flex-col gap-1 h-full overflow-hidden relative"
    style="max-width: 400px"
  >
    <q-tabs v-model="tab" class="text-teal" dense v-if="$route.query.asset">
      <q-tab name="config" label="Vehicle Config" />
      <q-tab name="tracker" label="Trackers" />
    </q-tabs>
    <q-tab-panels
      v-model="tab"
      animated
      class="flex-1"
      v-if="store.state.config"
    >
      <q-tab-panel
        name="config"
        class="flex flex-col gap-1 flex-1 overflow-auto flex-no-wrap"
      >
        <div class="text-sm font-bold">Tires Configuration</div>
        <q-separator />
        <div class="flex gap-2">
          <div class="flex w-1/2 flex-col gap-1">
            <template v-for="(tire, i) in ui.tyre">
              <FormInput
                v-if="store.state.config.tyre[tire.v]"
                :key="i"
                :data="tire"
                v-model="store.state.config.tyre[tire.v].count"
              />
            </template>
          </div>
          <div
            class="flex flex-col flex-1 items-end justify-between"
            :class="{ 'pointer-events-none': !$route.query.asset }"
          >
            <q-btn-group unelevated v-for="(tire, i) in ui.tyre">
              <q-btn
                :color="
                  store.state.config.tyre[tire.v].single
                    ? 'secondary'
                    : 'grey-9'
                "
                label="Single"
                padding="xs sm"
                class="text-xs"
                @click="store.state.config.tyre[tire.v].single = true"
              />
              <q-btn
                :color="
                  !store.state.config.tyre[tire.v].single
                    ? 'secondary'
                    : 'grey-9'
                "
                label="Pair"
                padding="xs sm"
                class="text-xs"
                @click="store.state.config.tyre[tire.v].single = false"
              />
            </q-btn-group>
          </div>
        </div>
        <q-separator spaced />
        <div class="w-full flex flex-1">
          <div class="w-1/2 flex flex-col gap-1">
            <div class="text-sm font-bold">Fuel Configuration</div>
            <div class="w-full flex flex-col gap-1" style="font-size: 10px">
              <span class="flex-1"
                >Number of Tanks
                <span class="font-semibold">
                  {{
                    !$route.query.asset
                      ? `: ${store.state.config.fuel.count}`
                      : ''
                  }}
                </span>
              </span>
              <vs-input-number
                v-if="store.state.config.fuel && $route.query.asset"
                :max="2"
                class="w-1/2"
                size="small"
                v-model.number="store.state.config.fuel.count"
              />
              <FormInput
                v-for="i in store.state.config.fuel.count"
                :key="i"
                :data="{ label: `Tank ${i}`, input: true }"
                v-model="store.state.config.fuel.tanks[i - 1]"
              />
              <!-- <div v-for="i in store.state.config.fuel.count" :key="i">
                {{ store.state.config.fuel }}
              </div> -->
            </div>
          </div>
          <q-separator spaced vertical />
          <div class="flex-1 flex gap-3 flex-col justify-start">
            <div class="text-sm font-bold">Mileage Configuration</div>

            <FormInput
              :data="{ label: `KM`, input: true }"
              v-model.number="store.state.config.mileage"
            />
          </div>
        </div>
      </q-tab-panel>
      <q-tab-panel name="tracker" class="flex flex-col gap-4">
        <q-btn
          fab
          color="primary"
          label="Make a Special Request"
          padding="xs sm"
          class="text-xs"
        />
        <div class="flex justify-center gap-4">
          <div
            v-for="(tracker, key) in ui.trackers"
            class="w-24 h-24 flex flex-center rounded-lg flex-center text-center text-white text-xs"
            :class="
              store.state.config.trackers[key] ? 'bg-success ' : 'bg-red '
            "
            style="border: solid 1px rgb(234, 234, 234)"
          >
            {{ tracker }}
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
    <div v-else>No Configuration Data</div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, nextTick } from 'vue';
import { store } from '../../api/api';

import FormInput from '../components/FormInput.vue';

const tab = ref('config');

const ui = {
  tyre: [
    { label: 'Front Tires', v: 'front', options: [1] },
    { label: 'Middle Tires', v: 'middle', options: [0, 1, 2, 3, 4] },
    { label: 'Back Tires', v: 'back', options: [0, 1, 2, 3] },
  ],
  trackers: {
    fuelSensor: 'Fuel Sensor',
    baseTracker: 'GPS Tracker',
    temperatureSensor: 'Temperature Sensor',
  },
};

const fuelTanks = ref(2);
const tanks = ref([{ v: 450 }, { v: 100 }]);
watch(
  () => store.state.config.fuel.count,
  (n, o) => {
    if (o != undefined) {
      if (n > o) {
        store.state.config.fuel.tanks.push(0);
      } else {
        store.state.config.fuel.tanks.pop();
      }
    }
  },
);
const mileage = ref(36459);

const trackers = ref([
  { label: 'GPS Tracker', v: true },
  { label: 'Fuel Sensor', v: true },
  { label: 'Temperature Sensor', v: false },
]);
watch(
  () => store.state.config.fuel,
  () => {
    if (!store.state.config.fuel.count) {
      store.state.config.fuel.count = 0;
    }
  },
);
</script>

<style lang="scss" scoped></style>
